import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'atlas-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TabComponent {
  @Input() label: string;
}
